/**
 * Analytics screen + event ids for Elite Plans.
 * `eventId` / `screenType` values are product contracts — rename only with analytics sign-off.
 *
 * ScreenLoaded: `screenType` is the route screen; `eventId` is
 * `${screen}_${tier}_${from}` (empty segments omitted) — not separate payload keys.
 */
export const ElitePlansAnalyticsScreen = {
  Landing: 'Elite_Plans_Landing',
  Member: 'Elite_Plans_Member',
  EliteLanding: 'Elite_Landing',
  EliteDashboard: 'Elite_Dashboard',
  PrimeLanding: 'Elite_Prime_Landing',
  PrimeDashboard: 'Elite_Prime_Dashboard',
  FamilyLanding: 'Elite_Plans_Family_Landing',
  FamilyMember: 'Elite_Plans_Family_Member',
  EliteFamilyLanding: 'Elite_Family_Landing',
  EliteFamilyDashboard: 'Elite_Family_Dashboard',
  PrimeFamilyLanding: 'Elite_Prime_Family_Landing',
  PrimeFamilyDashboard: 'Elite_Prime_Family_Dashboard'
} as const

export type ElitePlansAnalyticsScreenType =
  (typeof ElitePlansAnalyticsScreen)[keyof typeof ElitePlansAnalyticsScreen]

export const ElitePlansEventId = {
  TabSwitch: 'plan_tab_switch',
  CtaClick: 'primary_cta',
  CompareToggle: 'compare_toggle',
  FeatureOpen: 'feature_open',
  PlusItemClick: 'plus_item_click',
  ViewDetails: 'view_details',
  PricingDetailsClose: 'pricing_details_close',
  SlabRateToggle: 'slab_rate_toggle',
  KycConsentToggle: 'kyc_consent_toggle',
  PlanTenureToggle: 'plan_tenure_toggle',
  Back: 'webview_back'
} as const
